var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#logo-twitter';
                    var viewUrl = 'sprite.svg#view-logo-twitter';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?logo-twitter#logo-twitter';
                            viewUrl = 'sprite.svg?logo-twitter#view-logo-twitter';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 300 244.187',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };